import { Put, Post, Delete, Get } from "./common";

export default class CategoryService {
  static all = async (data: any) =>
    await Post({ path: "categories/all", body: data });

  static list = async (token: string, data: any) =>
    await Post({ path: "categories/list", token, body: data });

  static create = async (token: string, data: any) =>
    await Post({ path: "categories", token, body: data });

  static update = async (id: string, token: string, data: any) =>
    await Put({ path: `categories/${id}`, token, body: data });

  static getById = async (id: string) =>
    await Get({ path: `categories/${id}` });

  static deleteById = async (id: string, token: string) =>
    await Delete({ path: `categories/${id}`, token });

  static others = async () => await Post({ path: `categories/others` });
}
